module.exports = __webpack_public_path__ + "img/ltr_details.694dd5fc.png";